import { isValidMaxNumber, isValidNumber } from '../../../utils/validators';
import { ENumberErrorMessages } from '../constants';

export const numberValidator = (required: boolean) => (value: unknown) => {
  if (isValidNumber(value) && !isValidMaxNumber(Number(value))) {
    return ENumberErrorMessages.Max;
  }

  return (!value && !required) || isValidNumber(value) ? null : ENumberErrorMessages.Required;
};
